import { useCallback, useEffect, useMemo } from "react"

import { useStoreTemplates } from '@/modules/cms/views/post/components/builder/context'

import useList from "./useList"
import { templateRoot } from "./utils"

export default function useTemplatesList(type) {
  const { handleSave } = useStoreTemplates()
  const { add, remove, list } = useList(type.templates)

  const handleAdd = useCallback((template, isNew = false) => {
    if (!isNew) {
      return add(template)
    }
    const data = add(templateRoot(template))
    handleSave(data)
    return data
  }, [add, handleSave])

  useEffect(() => {
    type.templates = list
  }, [type, list])

  return useMemo(() => ({
    list,
    add: handleAdd,
    remove,
  }), [list, handleAdd, remove])
}

